<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="pro"><span class="epub-i">Prologue</span></p>
<p class="co">I could tell you what he looked like—his height and physique and the way the contours of his body felt close to mine in the dark; the shape and exact color of his eyes and how they looked when he was happy, sad, pissed, or passionate; the lines of his forearms, biceps, shoulders, and elbows; the curve of his lips and the feel of his mouth against mine; and what his back, and hips, and legs felt like beneath my fingertips. I could tell you what he smelled like and what he tasted like. I could pick his voice out in the crowd at Times Square on New Year’s Eve.</p>
<p class="tx">Even twenty-three years after the end, I could close my eyes and remember every detail of him, as clearly as if he were right in front of me.</p>
<p class="tx">But what would be the point in describing all that? All it would do—all it could possibly do—is diminish the whole into a rearrangement of features you would never see the way I saw them. He’d sound like your neighbor, or your brother, or that guy you work with, or some other person you couldn’t possibly imagine inspiring an unending ache in someone’s heart.</p>
<p class="tx">Everyone has a first love, one person they never completely got over, right?</p>
<p class="tx">Picture yours.</p>
<p class="tx">Because when you come down to it, it isn’t really anything about the way they look that distinguishes them in your memory—hair color, physical shape, style—it can all change with time. It’s the way you remember <span class="epub-i">feeling</span> when you looked at them.</p>
<p class="tx">When I looked at him, I felt real, unconditional love.</p>
<p class="tx">And I felt <span class="epub-i">completely</span> loved.</p>
<p class="tx">He was the only person I ever met whose soul I could clearly see in his eyes.</p>
<p class="tx">And I had more faith in him than I’ve ever had in another human being.</p>
<p class="tx">After I lost him, on the rare occasions when I saw him, I could feel the shape, the moving embodiment, of the hole in my heart.</p>
<p class="tx">Not that my life was about that. I moved on, of course. Dated, worked, ate, drank, laughed, cried. Had a child. Things happen, life goes on, and you have to keep moving and think about what’s in front of you or you’ll go insane.</p>
<p class="tx">So I pushed the part of me that belonged to him way beneath the surface.</p>
<p class="tx">Just like he did with me.</p>
<p class="tx">No one would ever have imagined this part of me existed at all, that a piece of my heart deep down was broken beyond repair, or that <span class="epub-i">that</span> guy—the guy who could have been <span class="epub-i">anyone</span> (or no one) to you or the rest of the world—was the cause of it all.</p>
<p class="tx">He was the only guy I was ever truly in love with. It took me years to move on.</p>
<p class="tx">Then he came back.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?3865dc1d